import kke from "../assets/work/kke.jpg";
import pokemac from "../assets/work/pokemac.jpg";
import drillbuddy from "../assets/work/drillbuddy.jpg";
import prayer from "../assets/work/prayer.jpg";

// Projects shown in the "Selected work" showcase on the home page.
// `frame` picks the mockup: "browser" (desktop site), "window" (Mac app), "phone" (mobile app).
// `tone` sets the tile colours to echo each project's own brand.
export const projects = [
  {
    id: "kke",
    name: "Shree Krishna Kalyan Export",
    kind: "Client website",
    sector: "Industrial supply & export",
    url: "https://www.krishnakalyanexport.com/en",
    domain: "krishnakalyanexport.com",
    image: kke,
    frame: "browser",
    summary:
      "Multilingual catalogue site for a Udaipur-based industrial supplier with 20 years in pumps, valves and fabrication, now exporting worldwide.",
    highlights: ["English, French & Arabic", "12 product lines", "Quote requests & WhatsApp"],
    tone: { bg: "#120f0d", fg: "#fbeee4", muted: "#c9b3a3", accent: "#f97316" },
  },
  {
    id: "pokemac",
    name: "PokeMac",
    kind: "Our product · macOS app",
    sector: "Consumer software",
    url: "https://poke-mac.com",
    domain: "poke-mac.com",
    image: pokemac,
    frame: "window",
    summary:
      "A playful menu-bar app for Apple Silicon that reacts to slaps, lid flips and USB plugs using the MacBook’s built-in sensors. Runs fully on-device.",
    highlights: ["Native macOS", "Accelerometer input", "No telemetry"],
    tone: { bg: "#7a0f45", fg: "#fff0f6", muted: "#f5b8d4", accent: "#ff5fa2" },
  },
  {
    id: "drillbuddy",
    name: "Drill Buddy",
    kind: "Our product · Android app",
    sector: "Sports training",
    url: "https://drillbuddy.online",
    domain: "drillbuddy.online",
    image: drillbuddy,
    frame: "phone",
    summary: "Audio-based reaction and agility drills for wrestling, MMA, badminton and more.",
    highlights: ["Google Play", "Adjustable intensity"],
    tone: { bg: "#0b1220", fg: "#e6fff4", muted: "#9fb3c8", accent: "#00f59b" },
  },
  {
    id: "prayer",
    name: "Personalized Prayer Counter",
    kind: "Our product · Android app",
    sector: "Wellbeing",
    url: "https://personalprayercounter.online",
    domain: "personalprayercounter.online",
    image: prayer,
    frame: "phone",
    summary: "A calm prayer counter with mala, digital and animated themes, daily totals and progress tracking.",
    highlights: ["8 languages", "Google Play"],
    tone: { bg: "#f6ecd6", fg: "#1f2a22", muted: "#6b6150", accent: "#2f7d4f" },
  },
];

// Client testimonials. Only add real quotes, with the client's permission.
// The testimonial block on the home page stays hidden while this list is empty.
// Example:
// { quote: "…", name: "Full name", role: "Title, Company", projectId: "kke" },
export const testimonials = [];
